import type { AuthTokenDtoSchema, LoginDtoSchema } from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const authApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<AuthTokenDtoSchema, LoginDtoSchema>({
            query: (body) => ({
                url: "auth/login",
                method: "POST",
                body,
            }),
        }),
    }),
});

export const { useLoginMutation } = authApi;
